import React from 'react'
import Select from '../../common/select/Select'
import type { ProfitCenter } from './types'
import css from './BudgetPlanning.css'
type ProfitCenterSelectProps = {
  options: Array<ProfitCenter>
  selectedOption: any
  onChange: (...args: Array<any>) => any
}

const ProfitCenterSelect = ({ options, selectedOption, onChange }: ProfitCenterSelectProps) => (
  <Select
    className={css.select}
    options={options.map((option) => ({ ...option, value: option.name }))}
    getOptionLabel={(option) => option.value}
    onChange={(option) => onChange(option.name)}
    value={selectedOption.name}
  />
)

export default ProfitCenterSelect
